/**
 * @file 帖子新旧数据兼容
 * @author Yongning.zhao 2024-06-19
 */
import { useMemo } from 'react';
import type { IArticalCover } from '@/api/thread/list';
import { oldThreadPhotoPrefix } from '@/constants/url';

/**
 * 处理帖子封面数据
 * @param covers
 * @returns
 */
export const formatArticalCovers = (covers: IArticalCover[] = []) => {
  return covers.map(
    ({ small, medium, large, extra_large: extraLarge, ...rest }) => {
      return {
        ...rest,
        small:
          small && !small?.startsWith('https://')
            ? `${oldThreadPhotoPrefix}/${small}`
            : small,
        medium:
          medium && !medium?.startsWith('https://')
            ? `${oldThreadPhotoPrefix}/${medium}`
            : medium,
        large:
          large && !large?.startsWith('https://')
            ? `${oldThreadPhotoPrefix}/${large}`
            : large,
        extra_large:
          extraLarge && !extraLarge?.startsWith('https://')
            ? `${oldThreadPhotoPrefix}/${extraLarge}`
            : extraLarge,
      };
    }
  );
};

export interface IUseFormatArticalContentProps {
  title?: string;
  covers?: IArticalCover[];
  summary?: string;
}

const useFormatArticalContent = ({
  title = '',
  summary = '',
  covers,
}: IUseFormatArticalContentProps) => {

  const formatTitle = useMemo(() => {
    if (title) {
      let temp: HTMLDivElement | null = document.createElement('div');
      temp.innerHTML = title;
      const tit = temp.textContent || temp.innerText;
      temp = null;
      return tit;
    }
    return '';
  }, [title]);

  // 帖子摘要 格式化
  const formatSummary = useMemo(() => {
    if (summary) {
      let temp: HTMLDivElement | null = document.createElement('div');
      temp.innerHTML = summary;
      const tit = temp.textContent || temp.innerText;
      temp = null;
      return tit;
    }
    return '';
  }, [summary]);

  return {
    formatTitle,
    formatSummary,
    formatCovers: formatArticalCovers(covers),
  };
};

export default useFormatArticalContent;
